// import React from 'react';
// import { Card } from 'react-bootstrap';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   PointElement,
//   LineElement,
//   LineController,
//   BarController,
//   Title,
//   Tooltip,
//   Legend,
// } from 'chart.js';
// import { Chart } from 'react-chartjs-2';

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   BarController,
//   PointElement,
//   LineElement,
//   LineController,
//   Title,
//   Tooltip,
//   Legend
// );

// const YTDChart = ({ ytdData = [], selectedPeriod, fromMonth, toMonth, year }) => {
//   // Defensive check: ensure ytdData is an array
//   if (!Array.isArray(ytdData)) {
//     console.warn('YTDChart: ytdData is not an array:', ytdData);
//     return (
//       <Card className="p-4">
//         <Card.Body>
//           <h5>YTD Environment KPIs Chart</h5>
//           <p>Invalid data format for YTD chart</p>
//         </Card.Body>
//       </Card>
//     );
//   }

//   if (ytdData.length === 0) {
//     return (
//       <Card className="p-4">
//         <Card.Body>
//           <h5>YTD Environment KPIs Chart</h5>
//           <p>No environment KPI data available for the selected YTD range ({fromMonth} to {toMonth} {year}).</p>
//         </Card.Body>
//       </Card>
//     );
//   }

//   // Group data by KPI for separate charts
//   const groupedByKPI = ytdData.reduce((acc, item) => {
//     const kpiName = item?.kpiName || item?.name || 'Unknown KPI';
//     if (!acc[kpiName]) {
//       acc[kpiName] = [];
//     }
//     acc[kpiName].push(item);
//     return acc;
//   }, {});

//   const colors = [
//     'rgba(54, 162, 235, 0.8)',
//     'rgba(75, 192, 192, 0.8)',
//     'rgba(255, 206, 86, 0.8)',
//     'rgba(255, 99, 132, 0.8)',
//     'rgba(153, 102, 255, 0.8)',
//     'rgba(255, 159, 64, 0.8)',
//     'rgba(199, 199, 199, 0.8)',
//     'rgba(83, 102, 255, 0.8)',
//     'rgba(255, 99, 255, 0.8)',
//     'rgba(99, 255, 132, 0.8)'
//   ];

//   const borderColors = [
//     'rgba(54, 162, 235, 1)',
//     'rgba(75, 192, 192, 1)',
//     'rgba(255, 206, 86, 1)',
//     'rgba(255, 99, 132, 1)',
//     'rgba(153, 102, 255, 1)',
//     'rgba(255, 159, 64, 1)',
//     'rgba(199, 199, 199, 1)',
//     'rgba(83, 102, 255, 1)',
//     'rgba(255, 99, 255, 1)',
//     'rgba(99, 255, 132, 1)'
//   ];

//   return (
//     <div>
//       <h5 className="mb-4">YTD Environment KPIs - {selectedPeriod} (Cumulative)</h5>
      
//       <div className="row">
//         {Object.entries(groupedByKPI).map(([kpiName, kpiData], index) => {
//           // Sort data by month order
//           const monthOrder = ["January", "February", "March", "April", "May", "June", 
//                              "July", "August", "September", "October", "November", "December"];
          
//           const sortedData = kpiData.sort((a, b) => 
//             monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month)
//           );

//           const chartColor = colors[index % colors.length];
//           const borderColor = borderColors[index % borderColors.length];

//           // Prepare chart data
//           const chartData = {
//             labels: sortedData.map(item => item.month),
//             datasets: [
//               {
//                 type: 'bar',
//                 label: 'Cumulative Current Value',
//                 data: sortedData.map(item => item.currentValue),
//                 backgroundColor: chartColor,
//                 borderColor: borderColor,
//                 borderWidth: 1,
//                 yAxisID: 'y',
//               },
//               {
//                 type: 'line',
//                 label: 'Cumulative Target Value',
//                 data: sortedData.map(item => item.targetValue),
//                 borderColor: 'rgba(255, 99, 71, 1)',
//                 backgroundColor: 'rgba(255, 99, 71, 0.2)',
//                 borderWidth: 3,
//                 fill: false,
//                 tension: 0.1,
//                 pointBackgroundColor: 'rgba(255, 99, 71, 1)',
//                 pointBorderColor: 'rgba(255, 99, 71, 1)',
//                 pointRadius: 5,
//                 yAxisID: 'y',
//               }
//             ],
//           };

//           const options = {
//             responsive: true,
//             maintainAspectRatio: false,
//             interaction: {
//               mode: 'index',
//               intersect: false,
//             },
//             plugins: {
//               title: {
//                 display: true,
//                 text: kpiName,
//                 font: {
//                   size: 14,
//                   weight: 'bold'
//                 }
//               },
//               legend: {
//                 display: true,
//                 position: 'top',
//               },
//               tooltip: {
//                 callbacks: {
//                   label: function(context) {
//                     let label = context.dataset.label || '';
//                     if (label) {
//                       label += ': ';
//                     }
//                     label += context.parsed.y.toFixed(2);
//                     return label;
//                   }
//                 }
//               }
//             },
//             scales: {
//               x: {
//                 display: true,
//                 title: {
//                   display: true,
//                   text: 'Months'
//                 }
//               },
//               y: {
//                 type: 'linear',
//                 display: true,
//                 position: 'left',
//                 title: {
//                   display: true,
//                   text: sortedData[0]?.unit || 'Value'
//                 },
//               },
//             },
//           };

//           return (
//             <div key={kpiName} className="col-md-6 mb-4">
//               <Card>
//                 <Card.Body>
//                   <div style={{ height: '350px', position: 'relative' }}>
//                     <Chart type='bar' data={chartData} options={options} />
//                   </div>
                  
//                   {/* Additional info */}
//                   <div className="mt-3">
//                     <small className="text-muted">
//                       <strong>Unit:</strong> {sortedData[0]?.unit || 'N/A'} | 
//                       <strong> Theme:</strong> Environment | 
//                       <strong> Type:</strong> {sortedData[0]?.fieldType || 'N/A'} |
//                       <strong> Dataset:</strong> {sortedData[0]?.dataset || 'N/A'}
//                     </small>
//                   </div>
                  
//                   {/* Data summary */}
//                   <div className="mt-2">
//                     <small className="text-muted">
//                       <strong>Data Summary:</strong> Showing {sortedData.length} months of cumulative data. 
//                       Values and targets are cumulative from year start to each month.
//                     </small>
//                   </div>
//                 </Card.Body>
//               </Card>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default YTDChart;







import React from 'react';
import { Card } from 'react-bootstrap';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  LineController,
  BarController,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  PointElement,
  LineElement,
  LineController,
  Title,
  Tooltip,
  Legend
);

// Custom plugin to draw horizontal target line
const targetLinePlugin = {
  id: 'targetLine',
  afterDraw: (chart) => {
    if (chart.options.plugins.targetLine && chart.options.plugins.targetLine.value !== undefined) {
      const { ctx, chartArea, scales: { y } } = chart;
      const targetValue = chart.options.plugins.targetLine.value;
      const targetYear = chart.options.plugins.targetLine.targetYear;
      
      const targetY = y.getPixelForValue(targetValue);
      
      // Check if target line is within visible area
      if (targetY >= chartArea.top && targetY <= chartArea.bottom) {
        ctx.save();
        
        // Draw main target line with gradient effect
        const gradient = ctx.createLinearGradient(chartArea.left, targetY, chartArea.right, targetY);
        gradient.addColorStop(0, 'rgba(220, 38, 38, 0.8)');
        gradient.addColorStop(0.5, 'rgba(220, 38, 38, 1)');
        gradient.addColorStop(1, 'rgba(220, 38, 38, 0.8)');
        
        ctx.strokeStyle = gradient;
        ctx.lineWidth = 3;
        ctx.setLineDash([12, 6]);
        ctx.beginPath();
        ctx.moveTo(chartArea.left, targetY);
        ctx.lineTo(chartArea.right, targetY);
        ctx.stroke();
        
        // Draw target indicator markers
        ctx.fillStyle = '#DC2626';
        ctx.fillRect(chartArea.left - 2, targetY - 3, 6, 6);
        ctx.fillRect(chartArea.right - 4, targetY - 3, 6, 6);
        
        // Add professional target label with enhanced styling
        let labelText;
        if (typeof targetValue === 'number' && !isNaN(targetValue)) {
          labelText = `Target (${targetYear}): ${targetValue.toFixed(2)}`;
        } else {
          labelText = `Target (${targetYear}): N/A`;
        }
        ctx.font = 'bold 12px Inter, Arial, sans-serif';
        ctx.textAlign = 'right';

        // Only draw the label text in red, no box or border
        ctx.fillStyle = '#DC2626';
        ctx.fillText(labelText, chartArea.right - 8, targetY - 8); // Draw above the line

        ctx.restore();
      }
    }
  }
};

ChartJS.register(targetLinePlugin);

const YTDChart = ({ ytdData = [], selectedPeriod, fromMonth, toMonth, year }) => {
  // Calculate target year (base year - 1)
  const currentYear = year || new Date().getFullYear();
  const targetYear = currentYear - 1;

  // Defensive check: ensure ytdData is an array
  if (!Array.isArray(ytdData)) {
    console.warn('YTDChart: ytdData is not an array:', ytdData);
    return (
      <Card className="shadow-lg border-0" style={{ borderRadius: '16px' }}>
        <Card.Body className="p-4">
          <div className="text-center">
            <div className="mb-3">
              <i className="fas fa-chart-bar text-muted" style={{ fontSize: '48px' }}></i>
            </div>
            <h5 className="text-muted mb-2">Invalid Chart Data</h5>
            <p className="text-muted small">Unable to render YTD Environment KPIs chart due to invalid data format.</p>
          </div>
        </Card.Body>
      </Card>
    );
  }

  if (ytdData.length === 0) {
    return (
      <Card className="shadow-lg border-0" style={{ borderRadius: '16px' }}>
        <Card.Body className="p-4">
          <div className="text-center">
            <div className="mb-3">
              <i className="fas fa-chart-line text-muted" style={{ fontSize: '48px' }}></i>
            </div>
            <h5 className="text-muted mb-2">No Data Available</h5>
            <p className="text-muted small">
              No environment KPI data found for the selected YTD period: 
              <br />
              <strong>{fromMonth} to {toMonth} {currentYear}</strong>
            </p>
          </div>
        </Card.Body>
      </Card>
    );
  }

  // Group data by KPI for separate charts
  const groupedByKPI = ytdData.reduce((acc, item) => {
    const kpiName = item?.kpiName || item?.name || 'Unknown KPI';
    if (!acc[kpiName]) {
      acc[kpiName] = [];
    }
    acc[kpiName].push(item);
    return acc;
  }, {});

  // Professional color palette with better contrast
  const colors = [
    '#1E40AF', // Professional Blue
    '#059669', // Emerald Green  
    '#DC2626', // Professional Red
    '#7C3AED', // Purple
    '#EA580C', // Orange
    '#0891B2', // Cyan
    '#4338CA', // Indigo
    '#BE185D', // Pink
    '#65A30D', // Lime
    '#374151'  // Gray
  ];

  const backgroundColors = [
    'rgba(30, 64, 175, 0.1)',   // Blue bg
    'rgba(5, 150, 105, 0.1)',   // Emerald bg
    'rgba(220, 38, 38, 0.1)',   // Red bg
    'rgba(124, 58, 237, 0.1)',  // Purple bg
    'rgba(234, 88, 12, 0.1)',   // Orange bg
    'rgba(8, 145, 178, 0.1)',   // Cyan bg
    'rgba(67, 56, 202, 0.1)',   // Indigo bg
    'rgba(190, 24, 93, 0.1)',   // Pink bg
    'rgba(101, 163, 13, 0.1)',  // Lime bg
    'rgba(55, 65, 81, 0.1)'     // Gray bg
  ];

  return (
    <div>
      {/* Enhanced Header */}
      <div className="mb-5">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h3 className="fw-bold text-dark mb-2 d-flex align-items-center">
              <i className="fas fa-chart-bar me-3 text-primary"></i>
              YTD Environment KPIs Dashboard
            </h3>
            <div className="d-flex align-items-center flex-wrap">
              <span className="badge bg-primary me-2 px-3 py-2">{selectedPeriod}</span>
              {/* Removed: Total aggregated values, dot, and KPIs tracked */}
            </div>
          </div>
          <div className="text-end">
            <div className="small text-muted">Reporting Period</div>
            <div className="fw-bold text-dark">{currentYear}</div>
            <div className="small text-muted">vs Target ({targetYear})</div>
          </div>
        </div>
      </div>
      
      <div className="row">
        {Object.entries(groupedByKPI).map(([kpiName, kpiData], index) => {
          const dataPoint = kpiData[0];
          const chartColor = colors[index % colors.length];
          const backgroundColor = backgroundColors[index % backgroundColors.length];

          // Prepare chart data with enhanced styling
          const chartData = {
            labels: [dataPoint.period],
            datasets: [
              {
                type: 'bar',
                label: `YTD Value (${currentYear})`,
                data: [dataPoint.currentValue],
                backgroundColor: backgroundColor,
                borderColor: chartColor,
                borderWidth: 3,
                borderRadius: 8,
                borderSkipped: false,
                hoverBackgroundColor: chartColor + '30',
                hoverBorderColor: chartColor,
                hoverBorderWidth: 4,
                yAxisID: 'y',
              }
            ],
          };

          const options = {
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
              mode: 'index',
              intersect: false,
            },
            animation: {
              duration: 1000,
              easing: 'easeInOutQuart',
            },
            plugins: {
              title: {
                display: true,
                text: kpiName,
                font: {
                  size: 16,
                  weight: 'bold',
                  family: 'Inter, system-ui, sans-serif'
                },
                color: '#111827',
                padding: {
                  top: 15,
                  bottom: 25
                }
              },
              legend: {
                display: true,
                position: 'top',
                labels: {
                  font: {
                    size: 13,
                    family: 'Inter, system-ui, sans-serif',
                    weight: '500'
                  },
                  color: '#374151',
                  padding: 20,
                  usePointStyle: true,
                  pointStyle: 'rectRounded',
                  boxWidth: 12,
                  boxHeight: 12
                }
              },
              tooltip: {
                enabled: true,
                backgroundColor: 'rgba(17, 24, 39, 0.95)',
                titleColor: '#F9FAFB',
                bodyColor: '#F9FAFB',
                borderColor: chartColor,
                borderWidth: 2,
                cornerRadius: 12,
                displayColors: true,
                usePointStyle: true,
                pointStyle: 'rectRounded',
                titleFont: {
                  size: 14,
                  weight: 'bold',
                  family: 'Inter, system-ui, sans-serif'
                },
                bodyFont: {
                  size: 13,
                  family: 'Inter, system-ui, sans-serif'
                },
                padding: 12,
                callbacks: {
                  title: function(context) {
                    return kpiName;
                  },
                  label: function(context) {
                    return `YTD (${currentYear}): ${context.parsed.y.toFixed(2)} ${dataPoint?.unit || ''}`;
                  },
                  afterLabel: function(context) {
                    return `Target (${targetYear}): ${dataPoint.targetValue.toFixed(2)} ${dataPoint?.unit || ''}`;
                  }
                  // Removed footer callback for performance
                }
              },
              targetLine: {
                value: dataPoint.targetValue,
                targetYear: targetYear
              }
            },
            scales: {
              x: {
                display: true,
                title: {
                  display: true,
                  text: 'Reporting Period',
                  font: {
                    size: 13,
                    weight: 'bold',
                    family: 'Inter, system-ui, sans-serif'
                  },
                  color: '#374151'
                },
                grid: {
                  display: false
                },
                ticks: {
                  font: {
                    size: 12,
                    family: 'Inter, system-ui, sans-serif',
                    weight: '500'
                  },
                  color: '#6B7280',
                  padding: 10
                },
                border: {
                  color: '#E5E7EB',
                  width: 2
                }
              },
              y: {
                type: 'linear',
                display: true,
                position: 'left',
                title: {
                  display: true,
                  text: dataPoint?.unit || 'Value',
                  font: {
                    size: 13,
                    weight: 'bold',
                    family: 'Inter, system-ui, sans-serif'
                  },
                  color: '#374151'
                },
                grid: {
                  color: '#F3F4F6',
                  lineWidth: 1,
                  borderDash: [2, 2]
                },
                border: {
                  color: '#E5E7EB',
                  width: 2
                },
                ticks: {
                  font: {
                    size: 12,
                    family: 'Inter, system-ui, sans-serif'
                  },
                  color: '#6B7280',
                  padding: 8,
                  callback: function(value) {
                    if (value >= 1000000) {
                      return (value / 1000000).toFixed(1) + 'M';
                    } else if (value >= 1000) {
                      return (value / 1000).toFixed(1) + 'K';
                    }
                    return value.toLocaleString();
                  }
                }
              },
            },
          };

          // Calculate performance metrics
          const performancePercentage = ((dataPoint.currentValue / dataPoint.targetValue) * 100);
          const isAboveTarget = performancePercentage >= 100;
          const performanceStatus = isAboveTarget ? 'Exceeding' : performancePercentage >= 80 ? 'On Track' : 'Below Target';
          const statusColor = isAboveTarget ? '#059669' : performancePercentage >= 80 ? '#F59E0B' : '#DC2626';

          return (
            <div key={kpiName} className="col-lg-6 mb-5">
              <Card className="shadow-lg border-0 h-100" style={{ 
                borderRadius: '16px',
                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)'
              }}>
                <Card.Body style={{ padding: '32px' }}>
                  <div style={{ height: '400px', position: 'relative', marginBottom: '24px' }}>
                    <Chart type='bar' data={chartData} options={options} />
                  </div>
                  
                  {/* Enhanced KPI Summary */}
                  <div className="mt-4 p-4" style={{ 
                    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
                    borderRadius: '12px',
                    border: '2px solid #e2e8f0'
                  }}>
                    <div className="row g-4">
                      <div className="col-6">
                        <div className="text-center">
                          <div className="text-muted small mb-2 fw-medium">YTD</div>
                          <div className="fw-bold h5 mb-1" style={{ color: chartColor }}>
                            {dataPoint?.currentValue?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) || 'N/A'}
                          </div>
                          <div className="small" style={{ color: chartColor, fontWeight: '600' }}>
                            {dataPoint?.unit || ''} ({currentYear})
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="text-center">
                          <div className="text-muted small mb-2 fw-medium">TARGET</div>
                          <div className="fw-bold h5 mb-1" style={{ color: '#DC2626' }}>
                            {dataPoint?.targetValue?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) || 'N/A'}
                          </div>
                          <div className="small text-danger fw-semibold">
                            {dataPoint?.unit || ''} ({targetYear})
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Enhanced metadata */}
                  <div className="mt-4">
                    <div className="row text-center g-3">
                      <div className="col-4">
                        <div className="p-3 rounded-3" style={{ backgroundColor: '#f8fafc' }}>
                          <small className="text-muted d-block mb-1 fw-medium">TYPE</small>
                          <small className="fw-bold text-dark">{dataPoint?.fieldType || 'N/A'}</small>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="p-3 rounded-3" style={{ backgroundColor: '#f8fafc' }}>
                          <small className="text-muted d-block mb-1 fw-medium">DATASET</small>
                          <small className="fw-bold text-dark text-capitalize">{dataPoint?.dataset || 'N/A'}</small>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="p-3 rounded-3" style={{ backgroundColor: '#f8fafc' }}>
                          <small className="text-muted d-block mb-1 fw-medium">PERIOD</small>
                          <small className="fw-bold text-dark">{dataPoint?.period || 'N/A'}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default YTDChart;